import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

// Component pages
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { CardModule, LayoutModule } from '@progress/kendo-angular-layout';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CommonTourModule } from "../shared/common-tour/common-tour.module";
import { LayoutComponent } from './layout.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { VerticalComponent } from './vertical/vertical.component';




@NgModule({
  declarations: [
    LayoutComponent,
    VerticalComponent,
    TopbarComponent,
    SidebarComponent,
    RightsidebarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgbNavModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    NgbCollapseModule,
    SimplebarAngularModule,
    IndicatorsModule,
    CommonTourModule,
    TooltipsModule,
    CardModule,
    LayoutModule
],
  providers: [],
})
export class LayoutsModule { }
